import { useNavigate } from "react-router-dom";
import React, { FormEvent, useCallback, useState } from "react";
import { sendResetEmail } from "../../firebase";
import { InfoBox } from "./info-box";
import { ErrorToast } from "./error-toast";
import { AuthError } from "@firebase/auth";

export const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSendResetEmail = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      sendResetEmail(email)
        .then(() => {
          setSuccess(true);
        })
        .catch((error: AuthError) => {
          setError(error.code);
        });
    },
    [email]
  );

  return (
    <div className="food xs:mt-16 xs:rounded shadow-xl mx-auto p-4 xs:max-w-sm">
      <form onSubmit={handleSendResetEmail}>
        <div className="w-full flex justify-center items-center">
          <h1 className="text-xl font-bold text-white mb-6">
            Wachtwoord herstellen
          </h1>
        </div>
        {error ? (
          <ErrorToast message={error} onDismiss={() => setError(null)} />
        ) : null}
        {success ? (
          <InfoBox color="green">De herstel email is verstuurd.</InfoBox>
        ) : null}
        <InfoBox>
          Vul je email adres in en klik op 'Herstel email versturen'.
        </InfoBox>
        <div className="mb-6">
          <label className="box-input-label mb-2" htmlFor="form-email">
            Email
          </label>
          <input
            className="box-input mb-3"
            id="form-email"
            type="text"
            value={email}
            onChange={(event) => {
              setEmail(event.currentTarget.value);
            }}
            placeholder="jouw@email.nl"
          />
        </div>

        <button className="btn-primary mb-12">
          <i className="fa fa-key mr-2 fa-2x" />
          <span>Herstel email vesturen</span>
        </button>
      </form>

      <button
        onClick={() => {
          navigate("/login");
        }}
        className="btn-secondary mb-6"
      >
        <i className="fa fa-sign-in-alt mr-2 fa-2x" />
        <span>Terug naar inloggen</span>
      </button>
    </div>
  );
};
